<template>
  <Rich :value="detail.content"></Rich>
</template>
<script>
export default {
  name: 'CustomPage',
  data() {
    return {
      id: this.$route.params.id,
      detail: {},
    };
  },
  async created() {
    let detail = await this.$http.get('/api/app/customPage/' + this.id);
    this.detail = detail;
    document.title = detail.name + '-' + this.$store.state.webConfig.web_title;
  },
};
</script>
